import { Link } from "react-router-dom";
import { ArrowRight, LifeBuoy } from "lucide-react";

const DEFAULT_TEXT = "Un projet : demandez votre devis. Une panne : notre support est ouvert de 7h à 17h, avec une prise en charge immédiate.";
import { Reveal } from "./Reveal";
import { onColor } from "../data/content";

export const CtaBand = ({ color = "#45ADE0", title = "Parlons de votre projet.", service, text = DEFAULT_TEXT, action }) => (
  <section data-testid="cta-band" className="bg-ink text-white relative overflow-hidden">
    <span className="absolute left-0 top-0 h-full w-2" style={{ background: color, color: onColor(color) }} />
    <div className="mx-auto max-w-7xl px-5 lg:px-8 py-20 lg:py-24 grid lg:grid-cols-12 gap-10 items-end">
      <Reveal className="lg:col-span-7">
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight">{title}</h2>
        <p className="mt-4 text-white/65 max-w-xl">{text}</p>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-5 flex flex-wrap gap-3 lg:justify-end">
        <Link to={action ? action[0] : service ? `/devis?service=${service}` : "/devis"} data-testid={action ? "cta-main-btn" : "cta-quote-btn"} className="btn-primary" style={{ background: color, color: onColor(color) }}>
          {action ? action[1] : "Demander un devis"} <ArrowRight size={18} />
        </Link>
        <Link to="/support" data-testid="cta-support-btn" className="btn-ghost-light">
          <LifeBuoy size={16} /> Assistance
        </Link>
      </Reveal>
    </div>
  </section>
);
